import { ObservableArray, View } from "binder"
import { productGroup, ProductGroupSelectorViewModel } from "./productGroupSelector-viewModel"

export class ProductGroupSelectorView extends View<ProductGroupSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-89EB5220-D338-4828-9A86-3C49EB01F2FE"
    }
    loadHtml(): string {
        let element = require('./productGroupSelector.html').default;
        let style = require('./productGroupSelector.less');
        return element;
    }
    constructor() {
       super();
    }

    public set groups(v: ObservableArray<productGroup>) { this._groups = v; } public get groups(): ObservableArray<productGroup> { return this._groups;} private _groups: ObservableArray<productGroup>;
    public set selectedGroup(v: productGroup) { this._selectedGroup = v; } public get selectedGroup(): productGroup { return this._selectedGroup;} private _selectedGroup: productGroup;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set selectedGroupName(v: string) { this._selectedGroupName = v; } public get selectedGroupName(): string { return this._selectedGroupName;} private _selectedGroupName: string;
    public set selectedGroupCode(v: string) { this._selectedGroupCode = v; } public get selectedGroupCode(): string { return this._selectedGroupCode;} private _selectedGroupCode: string;
    
    async refresh(){
        this.dataContext.refresh();
    }
}
